import React from "react";
import { ShoppingBag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCart } from "@/context/CartContext";
import { trackAddToCart } from "@/lib/analytics";

export default function BuyButton({ itemId, itemName, price, kind, className, children, testId, detail, workshopIds }) {
  const { add } = useCart();
  const inferred = kind || (itemId.startsWith("bundle_") ? "bundle" : { s: "service", r: "resource", w: "workshop" }[itemId[0]]);
  return (
    <Button
      className={className || "bg-emerald-600 hover:bg-emerald-700 rounded-full"}
      onClick={() => {
        const item = { item_id: itemId, name: itemName, price, kind: inferred, detail, workshop_ids: workshopIds };
        trackAddToCart(item);
        add(item);
      }}
      data-testid={testId || `buy-${itemId}`}
    >
      <ShoppingBag className="w-4 h-4" /> {children || `Add to basket · $${price}`}
    </Button>
  );
}
